// extracted by mini-css-extract-plugin
export var _basicDark = "button-module--_basic-dark--9805a";
export var _basicLight = "button-module--_basic-light--2d613";
export var _iconL = "button-module--_icon-l--48c55";
export var _iconR = "button-module--_icon-r--df7c2";
export var _large = "button-module--_large--6f660";
export var _primary = "button-module--_primary--6cd0f";
export var _small = "button-module--_small--4bedc";
export var _support = "button-module--_support--cbacc";
export var abstractButton = "button-module--abstract-Button--b3920";
export var abstractButtonContact = "button-module--abstract-Button-contact--c04b6";
export var abstractButtonLarge = "button-module--abstract-Button-large--5511e";
export var abstractButtonLogin = "button-module--abstract-Button-login--34be1";
export var abstractButtonMiddle = "button-module--abstract-Button-middle--83412";
export var abstractButtonSmall = "button-module--abstract-Button-small--712ed";
export var abstractMoreButton_Button = "button-module--abstract-MoreButton_Button--7c828";
export var abstractMoreButton_ButtonContract = "button-module--abstract-MoreButton_Button-contract--e3251";
export var abstractMoreButton_ButtonExpand = "button-module--abstract-MoreButton_Button-expand--37904";
export var abstractMoreButton_Outer = "button-module--abstract-MoreButton_Outer--332d0";
export var abstractMoreButton_OuterExpanded = "button-module--abstract-MoreButton_Outer-expanded--dd2b0";
export var swBtn = "button-module--sw-btn--a5c5a";